import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneOrderPayload } from '@app-store/slices/subscriptionOrder/oneOrder'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneOrderPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.orders.oneOrder

function* oneOrderSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/subscriptions/orders/one/${payload.orderId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneOrderSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneOrderSagaTask)
}

export default oneOrderSaga
